import router from '@/router';
export function pageTo(name, params) {
  router.push({name, params});
}
